import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { TimelineFragment } from '../../fragments/Timeline'
import { LoadingArea } from '../../components/LoadingArea'
import { EmptyMessage } from './StructureStructure'
import { ErrorMessage } from '../../fragments/Timeline'

import { Use as PartnerCountsData } from '../../data/partners/byId/counts'

const StructureTimelinePage: React.SFC<{}> = () => {
    const { t } = useTranslation(localStorage.getItem('localeBranch'))
    const partnerId = localStorage.getItem('partnerId')

    const { loading, error, data } = PartnerCountsData(partnerId)

    if (loading) return <LoadingArea size={400} />
    if (error) return <ErrorMessage><span>⚠</span> {t('error.error')}</ErrorMessage>

    const { sbibs, bibs, ibs, clients } = data

    if (!sbibs && !bibs && !ibs && !clients) return <EmptyMessage>{t('error.noStructure')}</EmptyMessage>

    return <TimelineFragment partnerId={partnerId} showNotificationsBar />
}

export { StructureTimelinePage }
